import angular from 'angular';

import MonitoringActionsPanelService from './MonitoringActionsPanelService';
import MonitoringActionsPanelComponent from './MonitoringActionsPanelComponent';

export default angular
  .module('petroCloud.dashboard.monitoringActionsPanel', [
    'ngSails'
  ])
  .service('MonitoringActionsPanelService', MonitoringActionsPanelService)
  .component(MonitoringActionsPanelComponent.name, MonitoringActionsPanelComponent)
  .name;
